// extracted by css-extract-rspack-plugin
export default {"flush":"SidebarActionList-module__flush__vc9MI","compact":"SidebarActionList-module__compact__wqVxV"};